<template>
  <div>
    <InputView type="text" v-if="parameter.type === 'text' && !parameter.placeholderable" :title="title" :min="parameter.min" :max="parameter.max" :value="value" @update:value="$emit('update:value', $event)" :invalid="invalid"/>
    <PlaceholderableTextInputView v-else-if="parameter.type === 'text' && parameter.placeholderable" :title="title" :placeholders="parameter.placeholders" :min="parameter.min" :max="parameter.max" :required="parameter.required" :value="value" @update:value="$emit('update:value', $event)" :multiline="parameter.multiline" :invalid="invalid">
      <template v-slot:placeholder="{ placeholder, preview }">
        <span v-if="preview" class="bg-secondary rounded-3" style="padding: 0.05em 0.3em; font-size: 0.9em">{{ placeholder.name }}</span>
        <span v-else>{{ placeholder.name }}</span>
      </template>
    </PlaceholderableTextInputView>
    <InputView type="number" v-else-if="parameter.type === 'number' || parameter.type === 'integer'" :title="title" :min="parameter.min" :max="parameter.max" :value="value" @update:value="$emit('update:value', $event)" :invalid="invalid"/>
    <SelectInputView v-else-if="parameter.type === 'boolean'" :title="title" :options="[{id: true, title: translate('yes')}, {id: false, title: translate('no')}]" required :value="value" @update:value="$emit('update:value', $event)" :invalid="invalid">
      <template v-slot:option="{ option }">
        {{ option.title }}
      </template>
    </SelectInputView>
    <DatePickerView v-else-if="parameter.type === 'date'" :title="title" :min="parameter.min" :max="parameter.max" :value="value" @update:value="$emit('update:value', $event)" :invalid="invalid">
      <template v-slot:target="{ toggle }">
        <ButtonView type="normal" color="secondary" @click="toggle">
          {{ value ? utilities.formatDatetime(value) : "" }}
        </ButtonView>
      </template>
    </DatePickerView>
    <DatePickerView v-else-if="parameter.type === 'dateTime'" :title="title" time :min="parameter.min" :max="parameter.max" :value="value" @update:value="$emit('update:value', $event)" :invalid="invalid">
      <template v-slot:target="{ toggle }">
        <ButtonView type="normal" color="secondary" @click="toggle">
          {{ value ? utilities.formatDatetime(value) : "" }}
        </ButtonView>
      </template>
    </DatePickerView>
    <DurationInputView v-else-if="parameter.type === 'duration'" :title="title" locale="en-US" :value="value" @update:value="$emit('update:value', $event)" :invalid="invalid"/>
    <InputView type="color" v-else-if="parameter.type === 'color'" :title="title" :value="value" @update:value="$emit('update:value', $event)" :invalid="invalid"/>
<!--    <InputRichText v-else-if="parameter.type === 'richText'" :features="parameter.features ?? []" :value="value" @update:value="$emit('update:value', $event)" :invalid="invalid"/>-->
    <FilteredSelectInputView v-else-if="parameter.type === 'select'" :title="title" :filter="({ query, item }) => item.title.toLowerCase().includes(query.toLowerCase())" :options="parameter.options" searchable :min="parameter.min" :max="parameter.max" :required="parameter.required" :multiple="parameter.multiple" :value="value" @update:value="$emit('update:value', $event)" :invalid="invalid">
      <template v-slot:option="{ option, preview }">
        <span v-if="preview" class="bg-secondary rounded-3" style="padding: 0.08em 0.3em; font-size: 0.9em">{{ option.title }}</span>
        <span v-else>{{ option.title }}</span>
      </template>
    </FilteredSelectInputView>
    <HttpSelectInputView v-else-if="parameter.type === 'selectModel'" :title="title" :endpoint="searchEndpoint" :min="parameter.min" :max="parameter.max" :required="parameter.required" :multiple="parameter.multiple" :value="value" @update:value="$emit('update:value', $event)" :invalid="invalid">
      <template v-slot:option="{ option, preview }">
        <span v-if="preview" class="bg-secondary rounded-3" style="padding: 0.08em 0.3em; font-size: 0.9em">{{ option.title }}</span>
        <span v-else>{{ option.title }}</span>
      </template>
    </HttpSelectInputView>
    <div v-else>
      <div class="alert alert-danger">
        Unknown form parameter type ({{ parameter.type }}).
      </div>
    </div>
  </div>
</template>

<script>
import {
  InputView,
  PlaceholderableTextInputView,
  DurationInputView,
  HttpSelectInputView,
  SelectInputView,
  ButtonView, utilities,
  DatePickerView,
  FilteredSelectInputView
} from "@niftybit/vue";
// import InputRichText from "@/components/global/richtext/InputRichText.vue";

export default {
  name: "FormParameterInput",
  components: {
    ButtonView, FilteredSelectInputView,
    PlaceholderableTextInputView, DatePickerView, SelectInputView, HttpSelectInputView, InputView, DurationInputView},
  emits: ["update:value"],
  props: {
    parameter: Object,
    value: [String, Number, Array, Boolean, Object],
    errors: [Array, Object],
    searchEndpoint: String,
    title: String
  },
  computed: {
    utilities() {
      return utilities
    },
    invalid() {
      return this.errors && (Array.isArray(this.errors) && this.errors.length > 0 || Object.keys(this.errors).length > 0);
    }
  }
}
</script>